import baseControllerInput from './baseControllerInput'
import { REQUIRED_ERROR_MESSAGE } from 'messages'

const DIGIT = /\d/
const ONE = /[1]/
const ONE_ZERO = /[1,0]/

export default baseControllerInput({
  getErrorMessage: state => {
    return state.input.value.length >= 1 ? '' : REQUIRED_ERROR_MESSAGE
  },
  maskConfig: {
    mask: (rawValue = '') => {
      if (rawValue.length === 1) {
        return [DIGIT]
      } else {
        return [ONE, ONE_ZERO]
      }
    },
    guide: false
  }
})
